import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconVeryDissatisfiedFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, i, l, u, _, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--very-dissatisfied-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Very Dissatisfied Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.391 6a5.438 5.438 0 1 1 10.875 0A5.438 5.438 0 0 1 .391 6ZM2.88 4.317a.438.438 0 0 1 .607-.123l.197.132c.19.125.436.125.624-.001l.194-.13a.438.438 0 0 1 .486.728l-.193.129a1.438 1.438 0 0 1-1.595.002l-.197-.13a.438.438 0 0 1-.123-.607Zm4.002.002a.437.437 0 0 1 .606-.122l.197.131c.19.126.436.126.624 0l.194-.13a.437.437 0 1 1 .486.727l-.193.13a1.437 1.437 0 0 1-1.595.002l-.197-.131a.437.437 0 0 1-.122-.607Zm-.993 1.803a2.579 2.579 0 0 0-1.57.505 2.206 2.206 0 0 0-.86 1.352.437.437 0 0 0 .43.518h4a.438.438 0 0 0 .43-.518 2.206 2.206 0 0 0-.859-1.352 2.579 2.579 0 0 0-1.57-.505Zm-.005.875a1.704 1.704 0 0 0-1.04.33 1.442 1.442 0 0 0-.296.295H7.23a1.442 1.442 0 0 0-.295-.295 1.704 1.704 0 0 0-1.04-.33h-.011Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ o(c, [["render", f]]);
export {
  b as default
};
//# sourceMappingURL=very-dissatisfied-filled.js.map
